const CONFIG = {
    SCREEN: {
        width: 768,
        height: 480,
    },
    WORLD: {
        width: 1536,
        height: 480,
    },
    GAME: {
        gravity: 2400
    },
    LEVELS: [
        {
            maxTicketCount: 4,
            snippetPerTicket: 4,
            pointsPerSnippet: 100,
            pointsPerBug: 200,
            pointsPerTicket: 400,
        }
    ]
}

export { CONFIG }


//////////////////
// WEBPACK FOOTER
// ./constants/index.js
// module id = 0
// module chunks = 0